module.exports = __webpack_public_path__ + "static/img/1.596d908.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/1.png
// module id = y+C4
// module chunks = 0